import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Sheet,
    Typography,
    FormControl,
    FormLabel,
    Input,
    Button,
    Link,
    Stack,
    Box,
    Alert
} from '@mui/joy';
import LockIcon from '@mui/icons-material/Lock';
import EmailIcon from '@mui/icons-material/Email';
import domain from '../utils/domain';

const AdminLogin: React.FC = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            const response = await fetch(`${domain}/api/auth/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email, password }),
                credentials: 'include'
            });

            const data = await response.json();
            console.log("response data:", data);
            if (!response.ok) {
                throw new Error(data.message || 'Login failed');
            }

            // Save token in localStorage
            if (data.token) {
                console.log(data.token);
                localStorage.setItem('adminToken', data.token);
            } else {
                throw new Error('No token received');
            }

            // Navigate to admin dashboard
            navigate('/admin/dashboard');
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Login failed');
            // Clear any existing token if login fails
            localStorage.removeItem('adminToken');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                minHeight: '100vh',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'background.level1',
            }}
        >
            <Sheet
                variant="outlined"
                sx={{
                    width: '100%',
                    maxWidth: 400,
                    mx: 2,
                    p: 3,
                    borderRadius: 'lg',
                }}
            >
                <Box sx={{ mb: 3, textAlign: 'center' }}>
                    <img
                        src={`${process.env.PUBLIC_URL}/logo-vector.svg`}
                        alt="Vector India Logo"
                        style={{
                            width: '200px',
                            height: 'auto',
                            marginBottom: '1rem'
                        }}
                    />
                    <Typography level="h3" sx={{ mb: 1 }}>
                        Admin Login
                    </Typography>
                    <Typography level="body-sm" sx={{ color: 'neutral.500' }}>
                        Sign in to access the admin dashboard
                    </Typography>
                </Box>

                {error && (
                    <Alert
                        color="danger"
                        variant="soft"
                        sx={{ mb: 2 }}
                    >
                        {error}
                    </Alert>
                )}

                <form onSubmit={handleSubmit}>
                    <Stack spacing={2}>
                        <FormControl>
                            <FormLabel>Email</FormLabel>
                            <Input
                                type="email"
                                placeholder="Enter your email"
                                startDecorator={<EmailIcon />}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </FormControl>

                        <FormControl>
                            <FormLabel>Password</FormLabel>
                            <Input
                                type="password"
                                placeholder="Enter your password"
                                startDecorator={<LockIcon />}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </FormControl>

                        <Button
                            type="submit"
                            loading={isLoading}
                            loadingPosition="start"
                            sx={{ mt: 1 }}
                        >
                            Sign In
                        </Button>

                        <Link
                            component="button"
                            type="button"
                            onClick={() => navigate('/exam')}
                            level="body-sm"
                            sx={{ alignSelf: 'center' }}
                        >
                            Back to Student Login
                        </Link>
                    </Stack>
                </form>
            </Sheet>
        </Box>
    );
};

export default AdminLogin; 